import {
	ADD_DATA,
	GET_ALL_DATA,
	UPDATE_DATA,
	DELETE_DATA,
	GET_VENDOR,
	GET_USER,
	CHANGE_STATUS,
	DETAIL,
	IMPORT_DATA,
	EXPORT_DATA,
	EXPORT_DATA_ID,
	GET_SUMMARY_DATA_DASHBOARD,
	GET_BY_ID,
	DOWNLOAD_FILE,
	GET_PO,
	SAVE_CONTRACT,
	GET_BUDGET_PLAN,
	GET_BUDGET_GL,
	GET_BUDGET_TASK,
	GET_BUDGET_TASK_DETAIL,
	UPDATE_CONTRACT,
	GET_HISTORICAL_DETAIL,
	SEND_NOTIFICATION,
	GET_AMANDEMENT_LIST_BY_ID,
	GET_CONTRACT_BY_AMANDEMENT,
	UPDATE_AMANDEMENT,
	GET_LIST_DETAIL_PAYMENT,
	GET_USER_UENROLL,
	GET_FOR_EDIT,
} from '@/api/listContract/contract';
import querystring from 'query-string';

const state = {
	excel: [],
	list: [],
	vendor: [],
	po: [],
	listUser: [],
	detail: null,
	historical: {},
	budget_plan: [],
	budget_gl: [],
	budget_task: [],
	budget_task_detail: [],
	listAmandement: [],
	amandementDetail: {},
	listDetailPayment: [],
	detailPayment: [],
	userUenroll: [],
};

const mutations = {
	SET_LIST: (state, payload) => {
		state.list = payload;
	},
	SET_VENDOR: (state, payload) => {
		state.vendor = payload;
	},
	SET_PO: (state, payload) => {
		state.po = payload;
	},
	SET_USER: (state, payload) => {
		state.listUser = payload;
	},
	SET_EXCEL: (states, payload) => {
		states.excel = payload;
	},
	SET_DETAIL: (state, payload) => {
		state.detail = payload;
	},
	SET_HISTORICAL: (state, payload) => {
		state.historical = payload;
	},
	SET_BUDGET_PLAN: (state, payload) => {
		state.budget_plan = payload;
	},
	SET_BUDGET_GL: (state, payload) => {
		state.budget_gl = payload;
	},
	SET_BUDGET_TASK: (state, payload) => {
		state.budget_task = payload;
	},
	SET_BUDGET_TASK_DETAIL: (state, payload) => {
		state.budget_task_detail = payload;
	},
	SET_LIST_AMANDEMENT: (state, payload) => {
		state.listAmandement = payload;
	},
	SET_AMANDEMENT: (state, payload) => {
		state.amandementDetail = payload;
	},
	SET_LIST_DETAIL_PAYMENT: (state, payload) => {
		state.detailPayment = payload;
	},
	RESET_DETAIL_TERM: (state, payload) => {
		state.detail = null;
	},
	SET_USER_UENROLL: (state, payload) => {
		state.userUenroll = payload;
	},
	SET_USER_UENROLL2: (state, payload) => {
		state.userUenroll2 = payload;
	},
};

const actions = {
	downloadExcel: async ({ commit }, args) => {
		const params = queryString.stringify(args);
		return await EXPORT_DATA(args)
			.then((res) => {
				const url = window.URL.createObjectURL(new Blob([res.data]));
				const link = document.createElement('a');
				link.href = url;
				link.setAttribute('download', args.filename + '.' + 'xlsx');
				document.body.appendChild(link);
				link.click();

				return res;
			})
			.catch((err) => {
				let resp = err.response;
				console.log(err);
			});
	},
	downloadID: async ({ commit }, args) => {
		return await EXPORT_DATA_ID(args.id)
			.then((res) => {
				const url = window.URL.createObjectURL(new Blob([res.data]));
				const link = document.createElement('a');
				link.href = url;
				link.setAttribute('download', args.filename + '.' + 'xlsx');
				document.body.appendChild(link);
				link.click();

				return res;
			})
			.catch((err) => {
				let resp = err.response;
				console.log(err);
			});
	},

	downloadFile: async ({ commit }, args) => {
		return await DOWNLOAD_FILE(args)
			.then((res) => {
				const blob = new Blob([response.data], { type: 'application/pdf' });
				const link = document.createElement('a');
				link.href = URL.createObjectURL(blob);
				link.download = 'label';
				link.click();
				URL.revokeObjectURL(link.href);
			})
			.catch((err) => {
				let resp = err.response;
				console.log(err);
			});
	},
	GET_USER_UENROLL: async ({ commit }, params) => {
		let dat = querystring.stringify(params);
		const resp = await GET_USER_UENROLL(dat);
		const data = resp.data.data;
		commit('SET_USER_UENROLL', data);
	},
	GET_USER_UENROLL2: async ({ commit }, params) => {
		let dat = querystring.stringify(params);
		const resp = await GET_USER_UENROLL(dat);
		const data = resp.data.data;
		commit('SET_USER_UENROLL2', data);
	},
	GET_LIST: async ({ commit }, params) => {
		params = querystring.stringify(params);
		const resp = await GET_ALL_DATA(params);
		const data = resp.data.data;
		commit('SET_LIST', data);
	},
	GET_VENDOR: async ({ commit }, params) => {
		params = querystring.stringify(params);
		const resp = await GET_VENDOR();
		const data = resp.data.data;
		commit('SET_VENDOR', data);
	},
	GET_PO: async ({ commit }) => {
		// const resp = await GET_PO();
		// const data = resp.data.data;
		// commit("SET_PO", data);
	},
	GET_USER: async ({ commit }, params) => {
		params = querystring.stringify(params);
		const resp = await GET_USER(params);
		const data = resp.data.data;
		commit('SET_USER', data);
	},

	GET_BY_ID: async ({ commit }, id) => {
		const resp = await GET_BY_ID(id);
		const data = resp.data.data;
		commit('SET_DETAIL', data);
	},

	GET_FOR_EDIT: async ({ commit }, id) => {
		const resp = await GET_FOR_EDIT(id);
		const data = resp.data.data;
		commit('SET_DETAIL', data);
	},

	GET_BUDGET_GL: async ({ commit }, id) => {
		const resp = await GET_BUDGET_GL(id);
		const data = resp.data.data;
		commit('SET_BUDGET_GL', data);
	},
	GET_BUDGET_PLAN: async ({ commit }) => {
		const resp = await GET_BUDGET_PLAN();
		const data = resp.data.data;

		commit('SET_BUDGET_PLAN', data);
	},
	GET_BUDGET_TASK: async ({ commit }, id) => {
		const resp = await GET_BUDGET_TASK(id);
		const data = resp.data.data;
		commit('SET_BUDGET_TASK', data);
	},
	GET_BUDGET_TASK_DETAIL: async ({ commit }, id) => {
		const resp = await GET_BUDGET_TASK_DETAIL(id);
		const data = resp.data.data;
		commit('SET_BUDGET_TASK_DETAIL', data);
	},

	CREATE_DATA: async ({ commit }, args) => {
		return await ADD_DATA(args);
	},
	UPDATE_DATA: async ({}, args) => {
		return await UPDATE_DATA(args);
	},

	DELETE_DATA: async ({}, id) => {
		return await DELETE_DATA(id);
	},
	CREATE_VENDOR: async ({}, args) => {
		return await GET_VENDOR(args);
	},
	CREATE_USER: async ({}, args) => {
		return await GET_USER(args);
	},

	CHANGE_STATUS: async ({ commit }, args) => {
		return await CHANGE_STATUS(args);
	},

	DETAIL_DATA: async ({}, id) => {
		return await DETAIL(id);
	},

	IMPORT_DATA: async ({ commit }, args) => {
		return await IMPORT_DATA(args);
	},
	saveContract: async ({ commit }, args) => {
		return await SAVE_CONTRACT(args);
	},
	updateContract: async ({ commit }, args, status, latestStatus) => {
		console.log('cmt', status);

		return await UPDATE_CONTRACT(args, status, latestStatus);
	},
	GET_HISTORICAL: async ({ commit }, id) => {
		const resp = await GET_HISTORICAL_DETAIL(id);
		const data = resp.data.data;
		commit('SET_HISTORICAL', data);
	},

	SEND_NOTIFICATION: async ({ commit }, args) => {
		return await SEND_NOTIFICATION(args);
	},

	GET_AMANDEMENT_LIST_BY_ID: async ({ commit }, id) => {
		const resp = await GET_AMANDEMENT_LIST_BY_ID(id);
		const data = resp.data.data;
		commit('SET_LIST_AMANDEMENT', data);
	},
	GET_CONTRACT_BY_AMANDEMENT: async ({ commit }, id) => {
		const resp = await GET_CONTRACT_BY_AMANDEMENT(id);
		const data = resp.data.data;
		commit('SET_AMANDEMENT', data); // Assuming it updates the detail state
	},
	UPDATE_AMANDEMENT: async ({ commit }, args) => {
		return await UPDATE_AMANDEMENT(args);
	},
	GET_LIST_DETAIL_PAYMENT: async ({ commit }, id) => {
		const resp = await GET_LIST_DETAIL_PAYMENT(id);
		const data = resp.data.data;
		commit('SET_LIST_DETAIL_PAYMENT', data);
	},
};

const getters = {
	list: (state) => state.list,
	detail: (state) => state.detail,
	historical: (state) => state.historical,
	listVendor: (state) => state.vendor,
	listpo: (state) => state.po,
	listUser: (state) => state.listUser,
	listBudgetPlan: (state) => state.budget_plan,
	listBudgetGL: (state) => state.budget_gl,
	listBudgetTask: (state) => state.budget_task,
	listBudgetTaskDetail: (state) => state.budget_task_detail,
	listAmandement: (state) => state.listAmandement,
	amandementDetail: (state) => state.amandementDetail,
	listDetailPayment: (state) => state.listDetailPayment,
	detailPayment: (state) => state.detailPayment,
	userUenroll: (state) => state.userUenroll,
	userUenroll2: (state) => state.userUenroll2,
};

export default {
	namespaced: true,
	state,
	actions,
	mutations,
	getters,
};
